// ============================================================================
// SAMPLE CATEGORY ENDPOINTS (Reference Implementation)
// ============================================================================
// Endpoint definitions for Service Category module

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

/**
 * Base path for category endpoints
 */
const BASE_PATH = '/categories';

/**
 * Category Endpoints
 */
export const sampleCategoryEndpoints = {
  /**
   * Get all categories
   * GET /categories
   */
  list: () => buildEndpoint(BASE_PATH),

  /**
   * Get category by ID
   * GET /categories/:id
   */
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Create new category
   * POST /categories
   */
  create: () => buildEndpoint(BASE_PATH),

  /**
   * Update category
   * PUT /categories/:id
   */
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Delete category
   * DELETE /categories/:id
   */
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Search categories
   * POST /categories/search
   */
  search: () => buildEndpoint(`${BASE_PATH}/search`),

  /**
   * Get category with services
   * GET /categories/:id/services
   */
  withServices: (id: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/:id/services`, { id }),

  /**
   * Get active categories
   * GET /categories/active
   */
  active: () => buildEndpoint(`${BASE_PATH}/active`),

  /**
   * Bulk delete categories
   * DELETE /categories/bulk
   */
  bulkDelete: () => buildEndpoint(`${BASE_PATH}/bulk`),
} as const;

/**
 * Export endpoints
 */
export default sampleCategoryEndpoints;
